module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_8.ae62bee2.svg";